import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader, EuiCard, EuiSteps,EuiLink } from '@elastic/eui';
import {Header } from './components/header';
import { Footer } from './components/footer';
import work1image1 from '../documents/work1image1.jpeg'
import work2image1 from '../documents/work2image1.png'
import work3image1 from '../documents/work3image1.png'
import work4image1 from '../documents/work4image1.jpg'
class Work extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
    }

    render() {
      const entreList = [
        { title:'Row House, Satara, India',
          children: (
            <EuiCard
                textAlign="left"
                title={<EuiText><b>Project - G+2 Row House spreading over 5500+ sq. feet</b></EuiText>}
                titleSize="s"
                description={<EuiText textAlign='right' size='xs'>(May 2021-Present)</EuiText>}
                image={<div>
                  <img style={{width: '100%',height: '40vw'}} src={work1image1} alt='work' />
                </div>}>
                  <EuiLink href={"/research/work1"}>Read More</EuiLink>
                </EuiCard>),
        },
        { title:'DM Constructions, Satara, India  ',
          children: (
            <EuiCard
                textAlign="left"
                title={<EuiText><b>Position: </b>Summer Intern <br/> <b>Project: </b>Ishanya Paradise (G+7 Residential Building, Karanje, Satara- 415002</EuiText>}
                titleSize="s"
                description={<EuiText textAlign='right' size='xs'>(May 2019) (March-June2020)</EuiText>}
                image={<div>
                  <img style={{width: '100%',height: '30vw'}} src={work2image1} alt='work' />
                </div>}>
                  <EuiLink href={"/research/work2"}>Read More</EuiLink>
                </EuiCard>),
        },    
      ]

      const internList = [
          {
            title: 'B.G.Shirke Construction Technologies Ltd., India ',
            children: (
              <EuiCard
                  textAlign="left"
                  title={<EuiText><b>Position: </b>Project Coordinator Apprentice<br/> <b>Project: </b>Maharashtra Housing & Area Development Authority- LIG (lower income group) and MIG (middle income group) scheme under Maharashtra Government</EuiText>}
                  titleSize="s"
                  description={<EuiText size='s'><EuiLink href='https://shirkegroup.com/' target="_blank">https://shirkegroup.com/</EuiLink> &emsp;&emsp;&emsp;&emsp;&emsp; January-May2021 </EuiText>}
                  image={<div>
                    <img style={{width: '100%',height: '30vw'}} src={work3image1} alt='work' />
                  </div>}>
                      <EuiLink href={"/research/work3"}>Read More</EuiLink>
                  </EuiCard>),
          },
          {
              title: 'Mantra Solid Waste Management Pvt. Ltd2',
              children: (
                  <EuiCard
                  textAlign="left"
                  title={<EuiText><b>Position: </b>Management Intern<br/> <b>Project: </b>Solid Waste Management Survey of Bibewadi, Pune</EuiText>}
                  titleSize="xs"
                  description={<EuiText textAlign='right' size='s'>(February-April 2018)</EuiText>} image={<div><img style={{width: '100%',height: '20vw'}}
                  src={work4image1}
                  alt="Nature"
                  href="/about"/></div>}>
                      <EuiLink href={"/research/work4"}>Read More</EuiLink>
                  </EuiCard>
              ),
            },
      ]

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                <EuiFlexGroup gutterSize='xl'>
                <EuiFlexItem>
                        <EuiSpacer />
                        <EuiText><h2><font face='Segoe UI'>Professional Equity</font></h2></EuiText>
                        <EuiSpacer size='m' />
                        <EuiText><h3><font face='Segoe UI'>Entrepreneur</font></h3></EuiText>
                        <EuiSpacer size='m' />
                        <EuiSteps titleSize='xs'steps={entreList}/>
                        <EuiText><h3><font face='Segoe UI'>Internship Experience</font></h3></EuiText>
                        <EuiSpacer size='m' />
                        <EuiSteps titleSize='xs'steps={internList}/>
                        <div>  
            </div>
                </EuiFlexItem>
                </EuiFlexGroup>
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { Work }